module.exports = __webpack_public_path__ + "img/3-2.b81a1ff2.png";